(function () {
  var html = document.documentElement;

  function armVideo(v) {
    if (!v) return;
    function ready() { v.classList.add("is-ready"); }
    v.addEventListener("canplay", ready);
    v.addEventListener("playing", ready);
    if (v.readyState >= 2) ready();
  }
  function syncHero() {
    var light = document.querySelector("[data-hero-light]");
    var darkv = document.querySelector("[data-hero-dark]");
    armVideo(light);
    armVideo(darkv);
    if (!light || !darkv) return;
    var dark = html.classList.contains("dark");
    if (dark) {
      light.pause();
      darkv.play().catch(function () {});
    } else {
      darkv.pause();
      light.play().catch(function () {});
    }
  }
  syncHero();

  window.woeGo = go;
  document.addEventListener("pointerdown", function (e) {
    if (!e.target.closest("[data-filters-open]")) return;
    var filters = document.querySelector("[data-filters]");
    var scrim = document.querySelector(".filters-scrim");
    if (!filters || filters.classList.contains("is-open")) return;
    filters.classList.add("is-open");
    document.body.classList.add("filters-lock");
    if (scrim) scrim.hidden = false;
  }, true);
  document.addEventListener("click", function (e) {
    var ig = e.target.closest("[data-ig-go]");
    if (ig) {
      var mode = ig.getAttribute("data-ig-mode") || "Offer";
      var name = document.querySelector(".product-name, h1");
      var msg = mode + " on " + ((name && name.textContent) || document.title);
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(msg).catch(function () {});
    }

    var offerBtn = e.target.closest("[data-offer-open]");
    if (offerBtn) {
      var panel = document.querySelector("[data-offer-panel]");
      if (!panel) return;
      panel.hidden = false;
      var mode = offerBtn.getAttribute("data-offer-mode") || "offer";
      var price = panel.querySelector("[data-offer-price]");
      var notes = panel.querySelector("[data-offer-notes]");
      if (price) price.parentElement.hidden = mode === "trade";
      if (notes) notes.parentElement.hidden = mode === "offer";
      panel.setAttribute("data-mode", mode);
      return;
    }
    if (e.target.closest("[data-offer-send]")) {
      var box = document.querySelector("[data-offer-panel]");
      var price = (document.querySelector("[data-offer-price]") || {}).value || "";
      var notes = (document.querySelector("[data-offer-notes]") || {}).value || "";
      var product = box ? box.getAttribute("data-product") : "";
      var handle = (box && box.getAttribute("data-ig")) || "walkingonearth.store";
      var msg = "Offer on " + product + "\nOffer: " + (price || "n/a") + "\nTrade: " + (notes || "n/a");
      var status = document.querySelector("[data-offer-status]");
      var openIg = function () { window.open("https://ig.me/m/" + handle, "_blank"); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(msg).then(function () {
          if (status) status.textContent = "Message copied. Paste it in the Instagram DM, then add photos.";
          openIg();
        }).catch(openIg);
      } else openIg();
      return;
    }

    var themeBtn = e.target.closest("[data-theme-toggle]");
    if (themeBtn) {
      var dark = html.classList.toggle("dark");
      try { localStorage.setItem("woe-theme", dark ? "dark" : "light"); } catch (err) {}
      syncHero();
      return;
    }

    if (e.target.closest("[data-search-toggle]")) {
      e.preventDefault();
      e.stopPropagation();
      var searchForm = document.querySelector(".search-form");
      var searchInput = document.querySelector("[data-search-input]");
      var header = document.querySelector(".shop-header");
      if (searchForm && searchForm.classList.contains("is-open") && searchInput && searchInput.value.trim()) {
        if (!document.querySelector("[data-product-grid]")) {
          if (searchForm.requestSubmit) searchForm.requestSubmit();
          else searchForm.submit();
        } else runSearch();
        return;
      }
      if (searchForm) {
        var open = !searchForm.classList.contains("is-open");
        searchForm.classList.toggle("is-open", open);
        if (header) header.classList.toggle("is-searching", open);
        if (open && searchInput) {
          window.setTimeout(function () {
            try { searchInput.focus({ preventScroll: true }); }
            catch (err) { searchInput.focus(); }
          }, 30);
        }
      }
      return;
    }

    if (e.target.closest("[data-filters-open]")) {
      e.preventDefault();
      var filters = document.querySelector("[data-filters]");
      var scrim = document.querySelector(".filters-scrim");
      if (filters) {
        filters.classList.add("is-open");
        document.body.classList.add("filters-lock");
        if (scrim) scrim.hidden = false;
      }
      return;
    }
    if (e.target.closest("[data-filters-close]")) {
      var filters = document.querySelector("[data-filters]");
      var scrim = document.querySelector(".filters-scrim");
      if (filters) {
        filters.classList.remove("is-open");
        document.body.classList.remove("filters-lock");
        if (scrim) scrim.hidden = true;
      }
      return;
    }

    var root = document.querySelector("[data-cart-root]");
    if (e.target.closest("[data-cart-open]")) {
      if (root) {
        e.preventDefault();
        refreshCart().then(function () { root.hidden = false; });
      }
      return;
    }
    if (e.target.closest("[data-cart-close]")) {
      if (root) root.hidden = true;
      return;
    }

    var thumb = e.target.closest("[data-pdp-thumb]");
    if (thumb) {
      e.preventDefault();
      goToShot(Number(thumb.getAttribute("data-pdp-index") || 0));
      return;
    }
    if (e.target.closest("[data-pdp-prev]")) {
      e.preventDefault();
      goToShot(currentShot() - 1);
      return;
    }
    if (e.target.closest("[data-pdp-next]")) {
      e.preventDefault();
      goToShot(currentShot() + 1);
      return;
    }

    var buy = e.target.closest("[data-buy-now]");
    if (buy) {
      e.preventDefault();
      var idEl = document.querySelector("[data-variant-id]");
      var id = idEl && idEl.value;
      if (!id) return;
      fetch("/cart/clear.js", { method: "POST" })
        .then(function () { return addToCart(id); })
        .then(function () { window.location.href = "/checkout"; })
        .catch(function () { if (buy.closest("form")) buy.closest("form").submit(); });
      return;
    }

    var milo = e.target.closest("[data-add-milo]");
    if (milo) {
      var idEl2 = document.querySelector("[data-variant-id]");
      var id2 = idEl2 && idEl2.value;
      if (!id2) return;
      addToCart(id2)
        .then(function () { return refreshCart(); })
        .then(function () {
          var drawer = document.querySelector("[data-cart-root]");
          if (drawer) drawer.hidden = false;
          else window.location.href = "/cart";
        })
        .catch(function () { if (milo.closest("form")) milo.closest("form").submit(); });
    }
  });

  function trackEl() { return document.querySelector("[data-pdp-track]"); }
  function slideEls() { return document.querySelectorAll(".pdp-slide"); }
  function thumbEls() { return document.querySelectorAll("[data-pdp-thumb]"); }
  function currentShot() {
    var t = trackEl();
    if (!t || !t.clientWidth) return 0;
    return Math.round(t.scrollLeft / t.clientWidth);
  }
  function syncThumbs(i) {
    var all = thumbEls();
    for (var n = 0; n < all.length; n++) all[n].classList.toggle("is-on", n === i);
  }
  function goToShot(i) {
    var t = trackEl();
    var slides = slideEls();
    if (!t || !slides.length) return;
    i = (i + slides.length) % slides.length;
    var left = slides[i].offsetLeft;
    if (t.scrollTo) t.scrollTo({ left: left, behavior: "smooth" });
    else t.scrollLeft = left;
    syncThumbs(i);
  }
  function bindGallery() {
    var t = trackEl();
    if (!t || t.dataset.bound === "1") return;
    t.dataset.bound = "1";
    var ticking = false;
    t.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        syncThumbs(currentShot());
        ticking = false;
      });
    }, { passive: true });
  }
  bindGallery();

  document.addEventListener("change", function (e) {
    if (!e.target.closest("[data-pick-variant]")) return;
    var hidden = document.querySelector("[data-variant-id]");
    if (hidden) hidden.value = e.target.value;
  });

  function addToCart(id) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: Number(id), quantity: 1 }),
    }).then(function (res) {
      if (!res.ok) throw new Error("Cart add failed");
      return res.json();
    });
  }
  function esc(s) {
    var amp = String.fromCharCode(38);
    var lt = String.fromCharCode(60);
    var gt = String.fromCharCode(62);
    var q = String.fromCharCode(34);
    return String(s || "").split(amp).join(amp + "amp;").split(lt).join(amp + "lt;").split(gt).join(amp + "gt;").split(q).join(amp + "quot;");
  }
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return "$" + (n % 1 === 0 ? String(n.toFixed(0)) : n.toFixed(2));
  }
  function refreshCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (cart) {
      var body = document.querySelector("[data-cart-body]");
      var foot = document.querySelector("[data-cart-foot]");
      var btn = document.querySelector("[data-cart-open]");
      if (btn) {
        var count = btn.querySelector(".cart-count");
        if (cart.item_count > 0) {
          if (!count) {
            count = document.createElement("span");
            count.className = "cart-count";
            btn.appendChild(count);
          }
          count.textContent = String(cart.item_count);
        } else if (count) count.remove();
      }
      if (!body) return;
      if (!cart.items || !cart.items.length) {
        body.innerHTML = '<div class="cart-empty"><img src="" alt="" width="80" height="80"><p>Milo’s cart is empty.</p></div>';
        var emptyImg = body.querySelector("img");
        var miloImg = document.querySelector(".cart-milo-btn img");
        if (emptyImg && miloImg) emptyImg.src = miloImg.src;
        if (foot) foot.hidden = true;
        return;
      }
      var html = '<ul class="cart-list">';
      cart.items.forEach(function (item) {
        var size = (item.variant_title && item.variant_title !== "Default Title") ? item.variant_title : "One Size";
        html += '<li class="cart-line"><a class="cart-thumb" href="' + item.url + '">';
        if (item.image) html += '<img src="' + item.image + '" alt="">';
        html += '</a><div class="cart-meta"><p class="product-card-brand">' + esc(item.vendor) + '</p>';
        html += '<p class="cart-title">' + esc(item.product_title) + '</p>';
        html += '<p class="muted">Size ' + esc(size) + '</p>';
        html += '<p class="product-card-price">' + money(item.final_line_price) + '</p></div></li>';
      });
      html += '</ul>';
      body.innerHTML = html;
      if (foot) {
        foot.hidden = false;
        var price = foot.querySelector(".product-card-price");
        if (price) price.textContent = money(cart.total_price);
      }
    });
  }

  /* Filters — title/brand/color only */
  var active = { size: {}, type: {}, color: {}, brand: {}, condition: {} };
  var searchQ = "";
  function on(k) {
    var out = [];
    for (var v in active[k]) if (active[k][v]) out.push(v);
    return out;
  }
  function hay(card) {
    var s = [
      card.getAttribute("data-hay") || "",
      card.getAttribute("data-sizes") || "",
      card.getAttribute("data-brand") || "",
      card.getAttribute("data-cat") || "",
    ].join(" ").toLowerCase();
    s = s.replace(/([a-z])([0-9])/g, "$1 $2").replace(/([0-9])([a-z])/g, "$1 $2");
    s = s.replace(/[^a-z0-9]+/g, " ");
    return " " + s.replace(/\s+/g, " ").trim() + " ";
  }
  function sizeHit(card, h, v) {
    var cat = (card.getAttribute("data-cat") || "").toLowerCase();
    var sizes = " " + (card.getAttribute("data-sizes") || "").toLowerCase()
      .replace(/([a-z])([0-9])/g, "$1 $2")
      .replace(/([0-9])([a-z])/g, "$1 $2")
      .replace(/[^a-z0-9.]+/g, " ") + " ";
    var title = " " + (card.getAttribute("data-title") || "").toLowerCase() + " ";
    var shoe = { gs: 1, "7": 1, "8": 1, "9": 1, "10": 1, "11": 1, "12": 1 };
    var cloth = { xs: 1, s: 1, m: 1, l: 1, xl: 1, xxl: 1 };
    if (shoe[v]) {
      if (cat !== "footwear") return false;
      if (v === "gs") {
        if (/\bgs\b/.test(sizes)) return true;
        if (/\b[1-6](?:\s*\.\s*5)?(?:\s*[mwy])?\b/.test(sizes)) return true;
        return false;
      }
      if (sizes.indexOf(" " + v + " ") !== -1) return true;
      if (sizes.indexOf(" " + v + " m ") !== -1) return true;
      if (sizes.indexOf(" " + v + " w ") !== -1) return true;
      return false;
    }
    if (v === "os") {
      if (cat === "footwear") return false;
      if (/\b(os|one size|adjustable)\b/.test(sizes) || /one size|adjustable/.test(title)) return true;
      if ((cat === "headwear" || cat === "bags" || cat === "pokemon") && !/\b(xxs|xs|s|m|l|xl|xxl)\b/.test(sizes)) return true;
      return false;
    }
    if (cloth[v]) {
      if (cat === "footwear") return false;
      var blob = (sizes + " " + title + " " + h).toLowerCase();
      if (v === "xs") return /\b(xs|x-small|xsmall|extra small)\b/.test(blob);
      if (v === "xxl") return /\b(xxl|2xl|2 xl|extra extra large)\b/.test(blob);
      if (v === "xl") return /\b(xl|extra large)\b/.test(blob) && !/\b(xxl|2xl|2 xl|extra extra large)\b/.test(blob);
      if (v === "s") return /\b(small|size s)\b/.test(blob) && !/\b(xs|x-small|xsmall|extra small)\b/.test(blob);
      if (v === "m") return /\b(medium|size m)\b/.test(blob) || blob.indexOf(" m ") !== -1;
      if (v === "l") return (/\b(large|size l)\b/.test(blob) || blob.indexOf(" l ") !== -1) && !/extra large/.test(blob);
      return blob.indexOf(" " + v + " ") !== -1;
    }
    return sizes.indexOf(" " + v + " ") !== -1;
  }
  var brandAlias = {
    bape: ["bape", "bathing ape"],
    "chrome-hearts": ["chrome hearts"],
    yeezy: ["yeezy", "yzy"],
    "louis-vuitton": ["louis vuitton"],
    "off-white": ["off white", "offwhite"],
    dior: ["dior"],
    moncler: ["moncler"],
    supreme: ["supreme"],
    burberry: ["burberry"],
    stussy: ["stussy"],
    carhartt: ["carhartt"],
    rhude: ["rhude"],
  };
  function typeHit(card, h, v) {
    return (card.getAttribute("data-cat") || "").toLowerCase() === v;
  }
  function cardCond(card) {
    return (card.getAttribute("data-condition") || "preowned").toLowerCase();
  }
  function colorBlob(card) {
    var s = (card.getAttribute("data-color") || card.getAttribute("data-title") || "").toLowerCase();
    s = s.replace(/ice\s*cream/g, " ");
    return " " + s.replace(/[^a-z0-9]+/g, " ").replace(/\s+/g, " ").trim() + " ";
  }
  function listedColors(blob) {
    var keys = [
      ["black", /\bblack\b/],
      ["blue", /\b(blue|navy|tiffany)\b/],
      ["brown", /\b(brown|tan)\b/],
      ["red", /\bred\b/],
      ["green", /\bgreen\b/],
      ["pink", /\bpink\b/],
      ["white", /\bwhite\b/],
      ["cream", /\b(cream|ivory|oatmeal)\b/],
      ["grey", /\b(grey|gray)\b/],
    ];
    var out = [];
    for (var i = 0; i < keys.length; i++) if (keys[i][1].test(blob)) out.push(keys[i][0]);
    return out;
  }
  function colorHit(card, v) {
    var blob = colorBlob(card);
    if (v === "multi-color") {
      if (/\b(multi|rainbow|colorblock)\b/.test(blob)) return true;
      return listedColors(blob).length >= 2;
    }
    if (v === "camo") return /\b(camo|camouflage)\b/.test(blob);
    if (v === "check") return /\b(check|plaid|nova|tartan)\b/.test(blob);
    if (v === "green") {
      if (/\btiffany\b/.test(blob)) return false;
      return /\bgreen\b/.test(blob);
    }
    if (v === "blue") return /\b(blue|navy|tiffany)\b/.test(blob);
    if (v === "cream") return /\b(cream|ivory|oatmeal)\b/.test(blob);
    if (v === "white") return /\bwhite\b/.test(blob.replace(/off white/g, " "));
    if (v === "black") return /\bblack\b/.test(blob);
    if (v === "brown") return /\b(brown|tan)\b/.test(blob);
    if (v === "red") return /\b(red|burgundy|scarlet|crimson|maroon|wine|cardinal)\b/.test(blob);
    if (v === "pink") return /\bpink\b/.test(blob);
    if (v === "grey") return /\b(grey|gray)\b/.test(blob);
    return blob.indexOf(" " + v.replace(/-/g, " ") + " ") !== -1;
  }
  function brandHit(card, v) {
    var b = " " + (card.getAttribute("data-brand") || "").toLowerCase().replace(/-/g, " ") + " ";
    if (v === "bape") return /\b(bape|bathing ape)\b/.test(b);
    if (v === "off-white") return /\boff white\b/.test(b);
    var key = v.replace(/-/g, " ");
    if (b.indexOf(" " + key + " ") !== -1) return true;
    var al = brandAlias[v] || [];
    for (var i = 0; i < al.length; i++) if (b.indexOf(" " + al[i] + " ") !== -1) return true;
    return false;
  }
  function editDist(a, b) {
    if (!a || !b) return 99;
    if (Math.abs(a.length - b.length) > 5) return 99;
    var prev = new Array(b.length + 1);
    var cur = new Array(b.length + 1);
    for (var j = 0; j <= b.length; j++) prev[j] = j;
    for (var i = 1; i <= a.length; i++) {
      cur[0] = i;
      for (var k = 1; k <= b.length; k++) {
        var cost = a.charAt(i - 1) === b.charAt(k - 1) ? 0 : 1;
        cur[k] = Math.min(prev[k] + 1, cur[k - 1] + 1, prev[k - 1] + cost);
      }
      var swap = prev; prev = cur; cur = swap;
    }
    return prev[b.length];
  }
  function missLimit(word) {
    if (word.length <= 3) return 1;
    if (word.length <= 5) return 2;
    if (word.length <= 8) return 3;
    return 4;
  }
  function closeWord(word, token) {
    if (!token) return false;
    if (token.indexOf(word) !== -1 || word.indexOf(token) !== -1) return true;
    return editDist(word, token) <= missLimit(word);
  }
  function cleanBlob(s) {
    return String(s || "").toLowerCase()
      .replace(/always buying\/trading bape/g, " ")
      .replace(/items all competing for purchase in store, everything goes fast!/g, " ");
  }
  function field(card, name) {
    return cleanBlob(card && card.getAttribute ? card.getAttribute(name) : card);
  }
  function sizeWord(word) {
    return { xs:1, s:1, m:1, l:1, xl:1, xxl:1, small:1, medium:1, large:1, os:1, "one":1 }[word] || /^\d{1,2}$/.test(word);
  }
  function colorWord(word) {
    return { black:1, white:1, red:1, blue:1, green:1, brown:1, pink:1, grey:1, gray:1, cream:1, navy:1, camo:1, check:1, plaid:1, multi:1, beige:1, yellow:1, orange:1, purple:1 }[word];
  }
  function brandWord(word) {
    return { bape:1, bapes:1, supreme:1, burberry:1, chrome:1, yeezy:1, nike:1, jordan:1, louis:1, vuitton:1, lv:1, gucci:1, off:1, white:1, vans:1, moncler:1 }[word];
  }
  function wordHit(word, blob, tokens) {
    if (!blob) return false;
    if (blob.indexOf(word) !== -1) return true;
    var aliases = { s:["small"], m:["medium"], l:["large"], xl:["xl"], xs:["xs"], small:["small"], medium:["medium"], large:["large"], bapes:["bape"], lv:["louis","vuitton"] };
    var al = aliases[word] || [];
    for (var a = 0; a < al.length; a++) if (blob.indexOf(al[a]) !== -1) return true;
    for (var t = 0; t < tokens.length; t++) if (closeWord(word, tokens[t])) return true;
    return false;
  }
  function titleHit(card, q) {
    var title = field(card, "data-title");
    var brand = field(card, "data-brand") + " " + title;
    var sizes = field(card, "data-sizes");
    var color = field(card, "data-color") + " " + title;
    var desc = field(card, "data-search");
    var words = String(q || "").toLowerCase().split(/\s+/).filter(function (w) { return w.length > 1 || sizeWord(w); });
    if (!words.length) return true;
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      var blob = desc;
      if (sizeWord(w)) blob = sizes + " " + title;
      else if (colorWord(w)) blob = color;
      else if (brandWord(w)) blob = brand;
      var tokens = blob.split(/[^a-z0-9]+/).filter(function (t) { return t.length > 1; });
      if (!wordHit(w, blob, tokens)) return false;
    }
    return true;
  }
  function searchScore(card, q) {
    var blob = field(card, "data-search") + " " + field(card, "data-title");
    var words = String(q || "").toLowerCase().split(/\s+/).filter(function (w) { return w.length > 0; });
    var tokens = blob.split(/[^a-z0-9]+/).filter(function (t) { return t.length > 1; });
    var score = 0;
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      var best = 99;
      if (blob.indexOf(w) !== -1) best = 0;
      for (var t = 0; t < tokens.length; t++) {
        var d = editDist(w, tokens[t]);
        if (d < best) best = d;
      }
      score += best;
    }
    return score;
  }
  function applyFilters() {
    var cards = document.querySelectorAll("[data-product-card]");
    var shown = 0;
    for (var i = 0; i < cards.length; i++) {
      var h = hay(cards[i]);
      var ok = true;
      var keys = ["size", "type", "color", "brand", "condition"];
      for (var k = 0; k < keys.length; k++) {
        var picked = on(keys[k]);
        if (!picked.length) continue;
        var hit = false;
        for (var p = 0; p < picked.length; p++) {
          if (keys[k] === "size") hit = hit || sizeHit(cards[i], h, picked[p]);
          else if (keys[k] === "brand") hit = hit || brandHit(cards[i], picked[p]);
          else if (keys[k] === "type") hit = hit || typeHit(cards[i], h, picked[p]);
          else if (keys[k] === "color") hit = hit || colorHit(cards[i], picked[p]);
          else if (keys[k] === "condition") hit = hit || (cardCond(cards[i]) === picked[p]);
        }
        if (!hit) ok = false;
      }
      if (searchQ && !titleHit(cards[i], searchQ)) ok = false;
      cards[i].hidden = !ok;
      if (ok) shown++;
    }
    if (searchQ && cards.length) {
      var parent = cards[0].parentNode;
      var ranked = [];
      for (var r = 0; r < cards.length; r++) if (!cards[r].hidden) ranked.push(cards[r]);
      ranked.sort(function (a, b) { return searchScore(a, searchQ) - searchScore(b, searchQ); });
      for (var s = 0; s < ranked.length; s++) parent.appendChild(ranked[s]);
    }
    var empty = document.querySelector("[data-filter-empty]");
    if (empty) empty.hidden = shown !== 0;
  }
  function paintSearch(raw) {
    applyFilters();
    var kick = document.querySelector("[data-results-kicker]");
    if (kick) kick.textContent = raw ? 'Results for “' + raw + '”' : "Newest arrivals";
    var empty = document.querySelector("[data-filter-empty]");
    if (empty) empty.textContent = raw ? 'Nothing titled “' + raw + '”' : "Nothing in the archive matches.";
    window.setTimeout(function () {
      var grid = document.querySelector("[data-product-grid]");
      if (grid) {
        try { grid.scrollIntoView({ behavior: "smooth", block: "start" }); }
        catch (err) { grid.scrollIntoView(); }
      }
    }, 50);
  }
  function shopUrl() {
    var header = document.querySelector("[data-shop-url]");
    var href = header && header.getAttribute("data-shop-url");
    if (href) return href;
    var logo = document.querySelector(".logo-script");
    return (logo && logo.getAttribute("href")) || "/collections/all?sort_by=created-descending";
  }
  function searchDest(raw) {
    var u = new URL(shopUrl(), location.href);
    var cur = new URL(location.href);
    ["preview_theme_id", "preview_token", "_ab", "_fd", "pb"].forEach(function (k) {
      if (cur.searchParams.get(k)) u.searchParams.set(k, cur.searchParams.get(k));
    });
    if (raw) u.searchParams.set("q", raw);
    else u.searchParams.delete("q");
    return u.pathname + u.search;
  }
  function showShopResults(html, dest, raw) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var next = doc.querySelector("main.woe-main");
    var cur = document.querySelector("main.woe-main");
    if (!next || !cur || !next.querySelector("[data-product-grid]")) return false;
    shopPark = null;
    var park = document.getElementById("woe-shop-park");
    if (park && park.parentNode) park.parentNode.removeChild(park);
    cur.innerHTML = next.innerHTML;
    document.title = doc.title;
    document.body.classList.remove("is-home");
    try { history.pushState({ woe: 1 }, "", dest); } catch (err) {}
    searchQ = (raw || "").toLowerCase();
    restoreSearch();
    applySavedFilter();
    window.scrollTo(0, 0);
    return true;
  }
  function leaveForSearch(raw) {
    var dest = searchDest(raw);
    var q = (raw || "").trim();
    try {
      sessionStorage.setItem("woe-q", q);
      sessionStorage.setItem("woe-q-go", "1");
    } catch (err) {}
    var main = document.querySelector("main.woe-main");
    if (!main) { window.location.assign(dest); return; }
    main.innerHTML = '<p class="empty">Searching…</p>';
    window.scrollTo(0, 0);
    var suggest = "/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=20";
    fetch(suggest, { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (data) {
      var items = (((data.resources || {}).results || {}).products) || [];
      if (!items.length) throw new Error("empty");
      paintFound(main, q, items, dest);
    }).catch(function () {
      fetch("/products.json?limit=250", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (data) {
        var needle = q.toLowerCase();
        var items = (data.products || []).filter(function (item) {
          return !needle || titleHit(item.title || "", needle);
        }).map(function (item) {
          var variant = (item.variants && item.variants[0]) || {};
          return { title: item.title, url: "/products/" + item.handle, image: item.images && item.images[0] && item.images[0].src, price: variant.price };
        });
        paintFound(main, q, items, dest);
      }).catch(function () {
        main.innerHTML = '<p class="empty">Search could not load. Try again.</p>';
      });
    });
  }
  function paintFound(main, q, items, dest) {
    var html = '<div class="product-grid" data-product-grid><p class="newest-kicker">' + (q ? "Results for " + esc(q) : "Newest arrivals") + '</p>';
    if (!items.length) html += '<p class="empty">Nothing in the archive matches.</p>';
    items.forEach(function (item) {
      var img = item.image || (item.featured_image && item.featured_image.url) || "";
      var price = item.price ? "$" + String(item.price).replace(/\.00$/, "") : "";
      var href = item.url || ("/products/" + item.handle);
      html += '<a class="product-card" href="' + esc(href) + '">';
      html += '<div class="product-card-img">';
      if (img) html += '<img src="' + esc(img) + '" alt="">';
      html += '</div><p class="product-card-brand">' + esc((item.title || "").split(" - ")[0]) + '</p>';
      html += '<h3 class="product-card-name">' + esc(item.title) + '</h3>';
      html += '<p class="product-card-size">Match</p>';
      html += '<p class="product-card-price">' + esc(price) + '</p></a>';
    });
    html += '</div>';
    main.innerHTML = html;
    document.body.classList.remove("is-home");
    try { history.pushState({ woe: 1 }, "", dest); } catch (err2) {}
  }
  function runSearch() {
    var inp = document.querySelector("[data-search-input]");
    var raw = ((inp && inp.value) || "").trim();
    active = { size: {}, type: {}, color: {}, brand: {}, condition: {} };
    var chips = document.querySelectorAll("[data-filter]");
    for (var c = 0; c < chips.length; c++) chips[c].classList.remove("is-on");
    searchQ = raw.toLowerCase();
    try { sessionStorage.setItem("woe-q", raw); } catch (err) {}
    if (inp) inp.blur();
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    var grid = document.querySelector("[data-product-grid]");
    if (!grid) {
      leaveForSearch(raw);
      return;
    }
    paintSearch(raw);
  }
  function clearSearch() {
    searchQ = "";
    var inp = document.querySelector("[data-search-input]");
    if (inp) inp.value = "";
    try {
      sessionStorage.removeItem("woe-q");
      sessionStorage.removeItem("woe-q-go");
    } catch (err) {}
    try {
      var u = new URL(location.href);
      if (u.searchParams.has("q")) {
        u.searchParams.delete("q");
        history.replaceState({ woe: 1 }, "", u.pathname + u.search);
      }
    } catch (err2) {}
    var kick = document.querySelector("[data-results-kicker]");
    if (kick) kick.textContent = "Newest arrivals";
  }
  function applySavedFilter() {
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem("woe-filter") || "null"); } catch (err) {}
    try { sessionStorage.removeItem("woe-filter"); } catch (err2) {}
    if (!saved || !saved.key || !saved.val) return;
    if (!document.querySelector("[data-product-grid]")) return;
    active[saved.key] = {};
    active[saved.key][saved.val] = true;
    var chips = document.querySelectorAll("[data-filter]");
    for (var i = 0; i < chips.length; i++) {
      var on = chips[i].getAttribute("data-filter") === saved.key && (chips[i].getAttribute("data-value") || "").toLowerCase() === saved.val;
      chips[i].classList.toggle("is-on", on);
    }
    applyFilters();
  }
  function restoreSearch() {
    var q = "";
    try { q = new URL(location.href).searchParams.get("q") || ""; } catch (err) {}
    if (!q) {
      try {
        if (sessionStorage.getItem("woe-q-go") === "1") q = sessionStorage.getItem("woe-q") || "";
      } catch (err2) {}
    }
    try { sessionStorage.removeItem("woe-q-go"); } catch (err3) {}
    if (!q) return;
    searchQ = q.toLowerCase();
    var inp = document.querySelector("[data-search-input]");
    if (inp) inp.value = q;
    var form = document.querySelector(".search-form");
    var header = document.querySelector(".shop-header");
    if (form) form.classList.add("is-open");
    if (header) header.classList.add("is-searching");
    if (document.querySelector("[data-product-grid]")) paintSearch(q);
  }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-brand-toggle]")) {
      e.preventDefault();
      var list = document.querySelector("[data-brand-list]");
      var btn = e.target.closest("[data-brand-toggle]");
      if (list) {
        var open = list.hasAttribute("hidden");
        if (open) list.removeAttribute("hidden");
        else list.setAttribute("hidden", "");
        if (btn) btn.classList.toggle("is-open", open);
      }
      return;
    }
    if (e.target.closest("[data-filter-clear]")) {
      e.preventDefault();
      active = { size: {}, type: {}, color: {}, brand: {}, condition: {} };
      var chips = document.querySelectorAll("[data-filter]");
      for (var i = 0; i < chips.length; i++) chips[i].classList.remove("is-on");
      applyFilters();
      return;
    }
    var chip = e.target.closest("[data-filter]");
    if (!chip) return;
    e.preventDefault();
    var key = chip.getAttribute("data-filter");
    var val = (chip.getAttribute("data-value") || "").toLowerCase();
    if (!active[key]) return;
    clearSearch();
    if (!document.querySelector("[data-product-grid]")) {
      try { sessionStorage.setItem("woe-filter", JSON.stringify({ key: key, val: val })); } catch (err) {}
      window.location.href = searchDest("");
      return;
    }
    active = { size: {}, type: {}, color: {}, brand: {}, condition: {} };
    active[key][val] = true;
    var chips = document.querySelectorAll("[data-filter]");
    for (var i = 0; i < chips.length; i++) {
      chips[i].classList.toggle("is-on", chips[i] === chip);
    }
    applyFilters();
  });

  function resultsPanel() {
    var panel = document.getElementById("woe-results");
    if (!panel) {
      panel = document.createElement("div");
      panel.id = "woe-results";
      panel.className = "woe-results";
      panel.hidden = true;
      document.body.appendChild(panel);
    }
    return panel;
  }
  function goSearch(raw) {
    raw = (raw || "").trim();
    var inp = document.querySelector("[data-search-input]");
    if (!raw && inp) raw = (inp.value || "").trim();
    if (inp) inp.blur();
    var panel = resultsPanel();
    panel.hidden = false;
    panel.innerHTML = '<p class="empty">Searching…</p>';
    window.scrollTo(0, 0);
    if (document.querySelector("[data-product-grid]")) {
      if (inp) inp.value = raw;
      runSearch();
      panel.hidden = true;
      return;
    }
    var suggest = "/search/suggest.json?q=" + encodeURIComponent(raw) + "&resources[type]=product&resources[limit]=20";
    fetch(suggest, { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (data) {
      var items = (((data.resources || {}).results || {}).products) || [];
      if (!items.length) throw new Error("empty");
      fillPanel(panel, raw, items);
    }).catch(function () {
      fetch("/products.json?limit=250", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (data) {
        var needle = raw.toLowerCase();
        var items = (data.products || []).filter(function (item) {
          return !needle || titleHit(item.title || "", needle);
        }).map(function (item) {
          var variant = (item.variants && item.variants[0]) || {};
          return { title: item.title, url: "/products/" + item.handle, image: item.images && item.images[0] && item.images[0].src, price: variant.price };
        });
        fillPanel(panel, raw, items);
      }).catch(function () {
        panel.innerHTML = '<p class="empty">Search could not load. Try again.</p>';
      });
    });
  }
  function fillPanel(panel, q, items) {
    var html = '<p class="newest-kicker">' + (q ? "Results for " + esc(q) : "Newest arrivals") + '</p><div class="product-grid">';
    if (!items.length) html += '<p class="empty">Nothing in the archive matches.</p>';
    items.forEach(function (item) {
      var img = item.image || "";
      var price = item.price ? "$" + String(item.price).replace(/\.00$/, "") : "";
      html += '<a class="product-card" href="' + esc(item.url || "#") + '"><div class="product-card-img">';
      if (img) html += '<img src="' + esc(img) + '" alt="">';
      html += '</div><p class="product-card-brand">' + esc((item.title || "").split(" - ")[0]) + '</p>';
      html += '<h3 class="product-card-name">' + esc(item.title) + '</h3>';
      html += '<p class="product-card-price">' + esc(price) + '</p></a>';
    });
    html += '</div>';
    panel.innerHTML = html;
  }
  window.woeSearch = goSearch;
  window.woeFilterSearch = function (raw) { searchQ = (raw || "").toLowerCase(); paintSearch(raw); };
  document.addEventListener("submit", function (e) {
    if (!e.target.closest("[data-search-form], .search-form")) return;
    var inp = e.target.querySelector("[data-search-input]");
    var raw = ((inp && inp.value) || "").trim();
    if (document.querySelector("[data-product-grid]")) {
      e.preventDefault();
      if (inp) inp.blur();
      searchQ = raw.toLowerCase();
      paintSearch(raw);
    }
  });
  function jumpSearch() {
    var inp = document.querySelector("[data-search-input]");
    var raw = ((inp && inp.value) || "").trim();
    if (inp) inp.blur();
    try {
      sessionStorage.setItem("woe-q", raw);
      sessionStorage.setItem("woe-q-go", "1");
    } catch (err) {}
    if (document.querySelector("[data-product-grid]")) {
      searchQ = raw.toLowerCase();
      paintSearch(raw);
      return;
    }
    location.href = searchDest(raw);
  }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-search-clear]")) {
      e.preventDefault();
      var inp = document.querySelector("[data-search-input]");
      if (inp) {
        inp.value = "";
        inp.focus();
      }
      clearSearch();
      var panel = document.getElementById("woe-results");
      if (panel) panel.hidden = true;
      if (document.querySelector("[data-product-grid]")) applyFilters();
      return;
    }
  });

  /* Stay on this page so DJ never unloads */
  try { history.scrollRestoration = "auto"; } catch (err) {}
  function sameOrigin(href) {
    try { return new URL(href, location.href).origin === location.origin; }
    catch (err) { return false; }
  }
  function hijack(a) {
    if (!a || a.target === "_blank" || a.hasAttribute("download")) return false;
    if (a.closest("[data-search-clear], [data-search-go], .search-form")) return false;
    var raw = a.getAttribute("href") || "";
    if (!raw || raw.charAt(0) === "#") return false;
    if (!sameOrigin(a.href)) return false;
    if (/\/checkouts?|\/account|\/admin|\/password/.test(a.pathname || a.href)) return false;
    return true;
  }
  function isProductPath(href) {
    return /\/products\//.test(href || "");
  }
  function shopY() {
    return window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
  }
  var shopPark = null;
  var lastY = 0;
  window.addEventListener("scroll", function () {
    if (document.querySelector("[data-product-grid]")) lastY = shopY();
  }, { passive: true });
  function parkShop() {
    var main = document.querySelector("main.woe-main");
    if (!main || !document.querySelector("[data-product-grid]")) return;
    if (shopPark) return;
    var y = lastY || shopY();
    var park = document.createElement("div");
    park.id = "woe-shop-park";
    park.hidden = true;
    park.style.display = "none";
    while (main.firstChild) park.appendChild(main.firstChild);
    main.parentNode.insertBefore(park, main);
    shopPark = { park: park, y: y, title: document.title };
    try { sessionStorage.setItem("woe-shop-y", String(y)); } catch (err) {}
  }
  function unparkShop(y) {
    if (!shopPark || !shopPark.park) return false;
    var main = document.querySelector("main.woe-main");
    if (!main) return false;
    while (main.firstChild) main.removeChild(main.firstChild);
    while (shopPark.park.firstChild) main.appendChild(shopPark.park.firstChild);
    if (shopPark.park.parentNode) shopPark.park.parentNode.removeChild(shopPark.park);
    document.title = shopPark.title;
    document.body.classList.remove("is-home");
    var top = typeof y === "number" ? y : shopPark.y;
    shopPark = null;
    window.scrollTo(0, top);
    return true;
  }
  function go(url, push, restoreY) {
        if (push && isProductPath(url)) parkShop();
    if (push) {
      try { history.pushState({ woe: 1 }, "", url); } catch (err) {}
    }
    if (!isProductPath(url) && shopPark) {
      unparkShop(typeof restoreY === "number" ? restoreY : 0);
      restoreSearch();
      return;
    }
    fetch(url, { credentials: "same-origin" }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var next = doc.querySelector("main.woe-main");
      var cur = document.querySelector("main.woe-main");
      if (!next || !cur) { location.replace(url); return; }
      cur.innerHTML = next.innerHTML;
      document.title = doc.title;
      document.body.className = doc.body.className;
      syncHero();
      bindGallery();
      restoreSearch();
      if (window.__woeDjPlaying && window.__woeDjPlaying()) {
        var boxes = document.querySelectorAll("[data-dj]");
        for (var i = 0; i < boxes.length; i++) boxes[i].classList.add("is-on");
        var audio = document.getElementById("dj-audio");
        if (audio && audio.paused) audio.play().catch(function () {});
      }
      if (typeof restoreY === "number" && restoreY > 0) window.scrollTo(0, restoreY);
      else if (push) window.scrollTo(0, 0);
    }).catch(function () { location.replace(url); });
  }
  document.addEventListener("pointerdown", function (e) {
    if (e.target.closest("[data-product-card], .product-card, a[href*='/products/']")) lastY = shopY();
  }, true);
  document.addEventListener("click", function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest("a");
    if (!hijack(a)) return;
    lastY = shopY();
    e.preventDefault();
    e.stopPropagation();
    if (a.classList.contains("logo-script")) {
      clearSearch();
      var form = document.querySelector(".search-form");
      var header = document.querySelector(".shop-header");
      if (form) form.classList.remove("is-open");
      if (header) header.classList.remove("is-searching");
      go(a.getAttribute("href") || a.href, true);
      return;
    }
    go(a.href, true);
  }, true);
  window.addEventListener("popstate", function () {
    var y = shopPark ? shopPark.y : lastY;
    try {
      var saved = parseInt(sessionStorage.getItem("woe-shop-y") || "0", 10) || 0;
      if (saved > 0) y = saved;
    } catch (err) {}
    go(location.href, false, y);
  });
  window.addEventListener("pageshow", function () {
    if (!document.querySelector("[data-product-grid]")) return;
    var y = 0;
    try { y = parseInt(sessionStorage.getItem("woe-shop-y") || "0", 10) || 0; } catch (err) {}
    if (y > 0) window.scrollTo(0, y);
  });
  var topBtn = document.querySelector("[data-to-top]");
  function syncTop() {
    if (!topBtn) return;
    topBtn.classList.toggle("is-on", (window.scrollY || 0) > 480 && !document.body.classList.contains("is-home"));
  }
  window.addEventListener("scroll", syncTop, { passive: true });
  if (topBtn) {
    topBtn.addEventListener("click", function () {
      try { window.scrollTo({ top: 0, behavior: "smooth" }); }
      catch (err) { window.scrollTo(0, 0); }
    });
  }
  syncTop();
  restoreSearch();
  applySavedFilter();
})();
